import {
  resolveFormOptionValues,
  resolveQuestionTypeRecord,
} from './create_sections_question_helpers.js';

export function resolveSelectedQuestionType(question_types, question_type_id) {
  const selected_type = resolveQuestionTypeRecord(question_types, question_type_id);
  return selected_type;
}

function buildQuestionPayloadBase(question_text, question_description, question_type_id, is_mandatory, is_unique, question_number) {
  const payload_base = {
    question_text,
    question_description,
    question_type_id,
    is_mandatory,
    is_unique,
    question_number,
    dependant_questions: [],
    trigger_condition: null,
  };
  return payload_base;
}

function cleanString(value) {
  return String(value || '').trim();
}

function parseQuestionNumberValue(value) {
  return Number.parseInt(value, 10) || null;
}

function resolveDependentOptions(dep_question, requires_options) {
  if (!requires_options || !Array.isArray(dep_question.options)) {
    const empty_options = [];
    return empty_options;
  }
  const dependent_options = dep_question.options
    .map((option) => cleanString(option?.choice || option))
    .filter(Boolean);
  return dependent_options;
}

function buildDependentQuestionBase(dep_question) {
  const dependant_question_payload = {
    question_text: cleanString(dep_question.question_text),
    question_type_id: Number(dep_question.question_type_id),
    is_mandatory: Boolean(dep_question.is_mandatory),
    is_unique: Boolean(dep_question.is_unique),
    question_number: parseQuestionNumberValue(dep_question.question_number),
  };
  return dependant_question_payload;
}

export function serializeDependentQuestion(ctx, dep_question) {
  const requires_options = ctx.question_type_requires_options(
    ctx.get_selected_question_raw_type(dep_question.question_type_id)
  );
  const dependant_question = {
    ...buildDependentQuestionBase(dep_question),
    options: resolveDependentOptions(dep_question, requires_options),
    trigger_condition: cleanString(dep_question.trigger_condition) || null,
    dependant_questions: Array.isArray(dep_question?.dependant_questions)
      ? dep_question.dependant_questions
        .map((child_question) => serializeDependentQuestion(ctx, child_question))
        .filter((child_question) =>
          child_question.question_text
          && child_question.question_type_id
          && child_question.trigger_condition
        )
      : [],
  };
  return dependant_question;
}

function resolveOptionValues(ctx, question_type_id, option_inputs) {
  const selected_type = resolveSelectedQuestionType(ctx.question_types, question_type_id);
  const option_values = ctx.question_type_requires_options(selected_type?.question_type)
    ? resolveFormOptionValues(option_inputs)
    : [];
  return option_values;
}

function resolveQuestionNumber(question_number, allow_parse = true) {
  if (Number.isInteger(question_number)) {
    return question_number;
  }
  if (allow_parse) {
    return Number.parseInt(question_number, 10) || null;
  }
  return null;
}

export function buildEditQuestionPayload(ctx) {
  const option_values = resolveOptionValues(
    ctx,
    ctx.current_edit_question.question_type_id,
    ctx.current_edit_question.option_inputs
  );
  const payload_base = buildQuestionPayloadBase(
    String(ctx.current_edit_question.question_text || '').trim(),
    String(ctx.current_edit_question.question_description || '').trim() || null,
    Number(ctx.current_edit_question.question_type_id),
    Boolean(ctx.current_edit_question.is_mandatory),
    Boolean(ctx.current_edit_question.is_unique),
    resolveQuestionNumber(ctx.current_edit_question.question_number)
  );
  const edit_question_payload = {
    ...payload_base,
    question_id: ctx.current_edit_question.question_id,
    multi_select_options: option_values,
    section_id: null,
  };
  return edit_question_payload;
}

function getQuestionText(value) {
  return String(value || '').trim();
}

function getQuestionDescription(value) {
  return String(value || '').trim() || null;
}

function getSectionId(section_id) {
  return Number(section_id) || null;
}

function buildQuestionPayloadInput(form, section_id) {
  const question_payload_input = {
    question_text: getQuestionText(form.question_text),
    question_description: getQuestionDescription(form.question_description),
    question_type_id: Number(form.question_type_id),
    is_mandatory: Boolean(form.is_mandatory),
    is_unique: Boolean(form.is_unique),
    question_number: resolveQuestionNumber(form.question_number, false),
    section_id: getSectionId(section_id),
  };
  return question_payload_input;
}

export function buildQuestionPayload(ctx, form, section_id) {
  const payload_input = buildQuestionPayloadInput(form, section_id);
  const question_payload = {
    ...buildQuestionPayloadBase(
      payload_input.question_text,
      payload_input.question_description,
      payload_input.question_type_id,
      payload_input.is_mandatory,
      payload_input.is_unique,
      payload_input.question_number
    ),
    multi_select_options: resolveOptionValues(
      ctx,
      form.question_type_id,
      form.option_inputs
    ),
    section_id: payload_input.section_id,
  };
  return question_payload;
}
